module.exports = __webpack_public_path__ + "img/dataIcon3.f2093183.svg";